export default __webpack_public_path__ + "static/media/PuraTernura.402406ac.png";